<template>
  <div :class="$style.container">
    <SearchComponent />
    <ContactsComponent v-show="searchResults.length" />
    <SearchingComponent v-show="isSearching" />
    <p v-if="noResults" :class="$style.noResults">Sorry, no contacts found</p>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SearchComponent from './SearchComponent'
import ContactsComponent from './ContactsComponent'
import SearchingComponent from './SearchingComponent'

const { mapState, mapGetters } = createNamespacedHelpers('dialer')

export default {
  components: {
    SearchComponent,
    ContactsComponent,
    SearchingComponent
  },
  computed: {
    ...mapState([
      'isSearching',
      'searchResults'
    ]),
    ...mapGetters([
      'noResults'
    ])
  }
}
</script>

<style module lang="less" src="./SearchMode.less"></style>



// WEBPACK FOOTER //
// SearchMode.vue?58999538